import React__default from "react";
import { useFloating, useTransitionStatus, useClick, useDismiss, useRole, useInteractions } from "@floating-ui/react";
const useLightbox = (props) => {
  const { isOpen, onOpenChange } = props;
  const data = useFloating({
    open: isOpen,
    onOpenChange
  });
  const context = data.context;
  const transitionStatus = useTransitionStatus(context, { duration: 600 });
  const click = useClick(context);
  const dismiss = useDismiss(context, { outsidePressEvent: "mousedown" });
  const role = useRole(context, { role: "dialog" });
  const interactions = useInteractions([click, dismiss, role]);
  return React__default.useMemo(
    () => ({
      ...interactions,
      ...data,
      ...context,
      ...transitionStatus
    }),
    [interactions, data, context, transitionStatus]
  );
};
export {
  useLightbox
};
